<template>
  <a-form
    ref="ruleForm"
    :rules="rules"
    :model="form"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :layout="layout"
  >
   <a-form-item :label="$t('js.ma_dia_diem')" name="code">
      <a-input v-model:value="form.code"  :placeholder="$t('js.vui_long_nhap_ma_dia_diem')"/>
    </a-form-item>
    <a-form-item :label="$t('js.ten_dia_diem')" name="title">
      <a-input v-model:value="form.title"  :placeholder="$t('js.vui_long_nhap_ten_dia_diem')"/>
    </a-form-item>
    <a-form-item :label="$t('js.tinh_thanh_pho')" name="province">
      <o-select
        ref="province"
        v-model:value="form.province"
        @input="onChangeProvince"
        :placeholder="$t('js.vui_long_chon_tinh_thanh_pho')"
        entity="province"
        :title="$t('js.tinh_thanh_pho')"
        :icon="'environment'"
        :isDisplay="'none'"
        :isDisplayAdd="'none'"
      />
    </a-form-item>
    <a-form-item :label="$t('js.quan_huyen')" name="district">
      <o-select
        ref="district"
        v-model:value="form.district"
        @input="onChangeDistrict"
        :placeholder="$t('js.vui_long_chon_quan_huyen_d086c739')"
        entity="district"
        :disabled="districtDisabled"
        :title="$t('js.quan_huyen')"
        :icon="'environment'"
        :isDisplay="'none'"
      />
    </a-form-item>
    <a-form-item :label="$t('js.phuong_xa')" name="ward">
      <o-select
        ref="ward"
        v-model:value="form.ward"
        @input="form.ward = $event"
        :placeholder="$t('js.vui_long_chon_phuong_xa')"
        entity="ward"
        :disabled="wardDisabled"
        :title="$t('js.phuong_xa')"
        :icon="'environment'"
        :isDisplay="'none'"
      />
    </a-form-item>
    <a-form-item :label="$t('js.dia_chi')" name="address">
          <a-input
            v-model:value="form.address"
            :placeholder="$t('js.vui_long_nhap_dia_chi')"
          />
        </a-form-item>
  </a-form>
</template>
<script >
import OneLogSelect from "@/components/Select/OneLogSelect";
import formUtility from "@/formUtility";
import { defineComponent } from "vue";

export default defineComponent({
  mixins: [formUtility],
  components: {
    "o-select": OneLogSelect,
  },
  props: {
    formData: {},
    width: String,
  },
  data() {
    let validateProvince = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject(window.__t('js.vui_long_tinh_thanh_pho'));
      } else {
        return Promise.resolve();
      }
    };
    let validateWard = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject(window.__t('js.vui_long_xa_phuong'));
      } else {
        return Promise.resolve();
      }
    };
    let validateDistrict = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject(window.__t('js.vui_long_quan_huyen'));
      } else {
        return Promise.resolve();
      }
    };
    const fields = [
      { name: "title", required: true, min: 0, max: 250 },
      {
        name: "province",
        validator: validateProvince,
        trigger: ["change", "blur"],
        required: true,
      },
      {
        name: "district",
        validator: validateDistrict,
        trigger: ["change", "blur"],
      },
      {
        name: "ward",
        validator: validateWard,
        trigger: ["change", "blur"],
      },
    ];
    let rules = this.generateRules("Location", fields);
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      layout: "horizontal",
      form: this.formData,
      rules,
      districtDisabled: true,
      wardDisabled: true,
    };
  },
  methods: {
    onChangeProvince($event) {
      this.form.province = $event;
      let item = this.$refs.district;

      this.districtDisabled = typeof $event == "undefined";
      this.form.district = void 0;

      this.wardDisabled = true;
      this.form.ward = void 0;

      this.onChangeLocation($event, item, "province_id");
    },
    onChangeDistrict($event) {
      this.form.district = $event;
      let item = this.$refs.ward;
      this.wardDisabled = typeof $event == "undefined";
      this.form.ward = void 0;
      this.onChangeLocation($event, item, "district_id");
    },
    onChangeLocation($event, item, field) {
      let value = $event ? $event.key : void 0;
      item.onLoad({ field, value });
    },
  },
});
</script>
<style scoped>
.ant-form-item {
  margin-bottom: 12px;
}
</style>
